<template>
  <card>
    <div slot="header">
      <b-row align-v="center">
        <b-col cols="8">
          <h3 class="mb-0">Manage My Account</h3>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="8">
          <small>
            Manage your account & billing information.
          </small>
        </b-col>
      </b-row>
    </div>

    <b-form @submit.prevent="updateProfile">
      <h6 class="heading-small text-muted mb-4">Account information</h6>

      <div class="pl-lg-4">
        <b-row>
          <b-col lg="12">
            <base-input
              type="email"
              label="Email address"
              placeholder="mike@email.com"
              v-model="user.email"
              disabled
            ></base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <base-input
              type="password"
              label="Password"
              placeholder="********"
              v-model="updatedUser.password"
            ></base-input>
          </b-col>
          <b-col lg="6">
            <base-input
              type="password"
              label="Confirm Password"
              placeholder="********"
              v-model="updatedUser.confirmPassword"
            ></base-input>
          </b-col>
          <span @click="updateAccount" class="btn btn-primary">
            Update password
          </span>
        </b-row>
        <b-row>
          <b-alert v-if="success" show variant="success" class="mt-2">
            <strong>Success!</strong>
            Your password has been updated.
          </b-alert>
        </b-row>
      </div>
      <hr class="my-4" />

      <!-- Address -->
      <!-- Description -->
      <h6 class="heading-small text-muted mb-4">Plans & billing</h6>

      <div v-if="hasPremium">
        <p>You have a premium account.</p>
        <a :href="billingUrl" class="btn btn-primary">Manage my billing</a>
      </div>

      <payment v-else ref="payment">
        <template v-slot:paymentbtn>
          <base-button @click="startCheckoutFlow" type="primary" class="mb-3">
            Upgrade Account
          </base-button>
        </template>
      </payment>
    </b-form>
  </card>
</template>
<script>
import Payment from "@/components/Payment";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {
    Payment
  },
  data() {
    return {
      billingUrl: "",
      success: false,
      updatedUser: {
        password: "",
        confirmPassword: ""
      }
    };
  },
  computed: {
    ...mapGetters("user", ["hasPremium"]),
    ...mapState("user", {
      user: (state) => state.user
    })
  },
  methods: {
    startCheckoutFlow() {
      this.$gtag.event("begin_checkout");
      this.$refs.payment.checkout();
    },
    updateProfile() {
      alert("Your data: " + JSON.stringify(this.user));
    },
    async updateAccount() {
      console.log("Updating account...");
      const resp = await this.$http.post("/user/updateAccount", {
        password: this.updatedUser.password,
        confirmPassword: this.updatedUser.confirmPassword
      });
      if (resp.data.success) {
        console.log("Updated user account");
        this.success = true;
      }
    }
  },
  mounted() {
    console.log("Getting billing session...");
    this.$http.get("/stripe/billingSession").then((resp) => {
      console.log("Got billing session!");
      console.log(resp);
      this.billingUrl = resp.data.session.url;
    });
  }
};
</script>
<style></style>
